<template>
  <div
    :style="section.styles.cssVariables.value"
    class="bg-(bg-default) text-(fg-default)"
    :class="[
      section.styles.spacerTop.value,
      section.styles.spacerBottom.value,
    ]"
  >
    <div
      class="container grid gap-20"
      :class="[
        section.styles.gridColumns.value,
      ]"
    >
      <div
        v-for="(speaker, index) in section.data?.value.items"
        :key="index"
        :class="[
          section.styles.textAlignment.value,
        ]"
      >
        <div
          v-if="section.data?.value.shownElements?.itemImage"
          class="flex"
          :class="[
            section.styles.textAlignment.value,
          ]"
        >
          <div
            class="overflow-hidden mb-6"
            :class="[
              section.styles.imageSize.value,
              section.styles.imageCrop.value,
              section.styles.cornerRadius.value,
              {
                'bg-(fg-muted)': !speaker.profilePhoto,
              },
            ]"
          >
            <img
              v-if="speaker.profilePhoto"
              :src="`${useRuntimeConfig().public.imagekit}${useRuntimeConfig().public.imagekit ? '/tr:w-800,c-at_max/' : ''}${speaker.profilePhoto}`"
              class="h-full object-cover"
              :alt="sanitize(speaker[section.lang.value]?.title)"
            >
          </div>
        </div>
        <h2
          v-if="section.data?.value.shownElements?.itemName"
          class="text-lg"
          v-html="sanitize(speaker[section.lang.value]?.title)"
        />
        <p
          v-if="section.data?.value.shownElements?.itemOccupation && speaker[section.lang.value]?.occupation"
          class="text-base mt-0"
          v-html="sanitize(speaker[section.lang.value]?.occupation)"
        />
        <div
          v-if="section.data?.value.shownElements?.itemBio && speaker[section.lang.value]?.bio"
          class="text-lg mt-6"
          v-html="sanitize(speaker[section.lang.value]?.bio)"
        />
        <div
          v-if="section.data?.value.shownElements?.itemLinks && speaker.profileLinks?.length"
          class="inline-flex flex-wrap gap-1 mt-6"
        >
          <a
            v-for="(profileLink, profileIndex) in speaker.profileLinks"
            :key="profileIndex"
            :href="profileLink.value"
            target="_blank"
          >
            <Icon
              :name="useBuilderStore().getContactLinkType(profileLink.type)?.icon"
              class="rounded p-2 text-(fg-subtle) w-10 h-10 border border-(border-default) transition hover:scale-105"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const section = usePageSection(props);
</script>
